import * as Inovx from '@shared';
import BaseService from '@shared/services/BaseService';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/RoleApi/api/role`;

var RoleServices: IRoleServices = {
    ...BaseService,
    getAll: function (successCallback: (retData: IOrganizationRole[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(url,
            null,
            (retData: IOrganizationRole[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    },
    getRoleDetail: function (id: string, successCallback: (retData: IOrganizationRoleDetail) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/${id}`,
            null,
            (retData: IOrganizationRoleDetail) => {
                successCallback(retData)
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },
    createRole: function (role: IOrganizationRole, externalGroupIDs: string[], successCallback: (retData: IOrganizationRole) => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Create`,
            { role, externalGroupIDs },
            (retData: IOrganizationRole) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },
    editRole: function (role: IOrganizationRole, externalGroupIDs: string[], successCallback: (retData: IOrganizationRole) => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Update`,
            { role, externalGroupIDs },
            (retData: IOrganizationRole) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },
    deleteRole: function (role: IOrganizationRole, successCallback: () => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Delete`,
            { ID: role.ID, VersionToken: role.VersionToken },
            () => {
                successCallback();
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            }
        );
    },
    searchGroup: function (hint: string, successCallback: (data: IExternalGroup[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/QueryDirectory`,
            { nameHint: hint },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },
    getSettings: function (successCallback: (retData: IRoleSettings) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/Settings`,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    }
};

export default RoleServices;
